var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8887 7.72217C15.8887 11.8652 12.5305 15.2222 8.38867 15.2222C4.24683 15.2222 0.888672 11.8652 0.888672 7.72217C0.888672 3.58153 4.24683 0.222168 8.38867 0.222168C12.5305 0.222168 15.8887 3.58153 15.8887 7.72217ZM8.38867 9.23426C7.62038 9.23426 6.99754 9.8571 6.99754 10.6254C6.99754 11.3937 7.62038 12.0165 8.38867 12.0165C9.15697 12.0165 9.7798 11.3937 9.7798 10.6254C9.7798 9.8571 9.15697 9.23426 8.38867 9.23426ZM7.06792 4.23388L7.29225 8.34678C7.30274 8.53924 7.46188 8.68991 7.65461 8.68991H9.12273C9.31547 8.68991 9.4746 8.53924 9.48509 8.34678L9.70943 4.23388C9.72077 4.026 9.55525 3.8512 9.34707 3.8512H7.43024C7.22206 3.8512 7.05657 4.026 7.06792 4.23388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5e5f6af24a278e3d0f5d2be90ffa66eb.svg";
export { ForwardRef as ReactComponent };